import { StandardProps } from "@/components/componentMap";
import styles from "./PriceUnitPriceAndRating.module.scss";
import { Price } from "@/components/Price/Price";
import { UnitPrice } from "@/components/UnitPrice/UnitPrice";
import { RatingAndReviews } from "@/components/RatingAndReviews/RatingAndReviews";

export function PriceUnitPriceAndRating({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  return (
    <div className={styles.wrapper}>
      {/*** include components here ***/}
      <div className={styles.priceAndUnitPrice}>
        <Price product={product} configProps={configProps} flags={flags} />
        <UnitPrice product={product} />
      </div>
      <RatingAndReviews
        product={product}
        configProps={configProps}
        flags={flags}
      />
    </div>
  );
}
